module.exports = __webpack_public_path__ + "media/symboldecryption.f330a8b4.mp4";